// A drawing on blueprint blue with the grid showing through, taped to the
// page. The tape sits outside the clip so it overhangs, as tape does.
import type { CSSProperties } from 'react';
import { Tape } from './Tape';
import { cx } from './cx';

export interface BlueprintProps {
  src: string;
  alt: string;
  /** Leave out for an untaped drawing (a thumbnail). */
  seed?: string | number;
  width?: number | string;
  className?: string;
}

export function Blueprint({ src, alt, seed, width, className }: BlueprintProps) {
  return (
    <div className={cx('blueprint-frame', className)} style={{ width } as CSSProperties}>
      <div className="blueprint">
        <img src={src} alt={alt} />
        <span className="blueprint-grid" aria-hidden="true" />
      </div>
      {seed !== undefined && <Tape seed={seed} />}
    </div>
  );
}
